<template>
  <footer class="footer">
    <div class="footer-container">
      <FavLink />
    </div>
  </footer>
</template>
<script>
import FavLink from '@/components/common-btn/fav-link.vue';
export default {
  name: "PageFooter",
  components: {
    FavLink,
  }
}
</script>
<style lang="scss" scoped>
.footer {
  width: 100%;
  padding: 8px 12px;
  line-height: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/page-footer/index.vue